import { useEffect } from 'react';
import { useBusinessChannelEventBinder } from '~/pusher/useBusinessChannelEventBinder';
import { tasksStore } from '../../tasksStore';
export function useRelationshipPdfCardEvents(jobId) {
    const { startListening } = useBusinessChannelEventBinder('RelationshipPdfUpdate', 'scout');
    useEffect(()=>{
        startListening((payload)=>{
            if (payload.jobId !== jobId || payload.kind !== 'relationshipPdf') return;
            if (payload.status === 'ready') {
                tasksStore.updateTask(jobId, {
                    status: 'ready',
                    progress: 100,
                    downloadUrl: payload.downloadUrl,
                    fileName: payload.fileName
                });
                return;
            }
            if (payload.status === 'failed') {
                tasksStore.updateTask(jobId, {
                    status: 'failed',
                    progress: 100,
                    error: payload.error
                });
                return;
            }
            tasksStore.updateTask(jobId, {
                status: payload.status,
                progress: payload.progress
            });
        });
    }, [
        jobId,
        startListening
    ]);
}
